import { ActionButton, CalendarHeader, TableComponent, Tabs } from "components"

import _ from "lodash"
import { render } from "@testing-library/react"
import { useAppNavigate } from "_graphql/cache/auth"
import { useBankingTray } from "hooks/data/use-banking-tray"
import { useUrlState } from "utils"

type Props = {}


const tabColumns = {
    "1": [{
        name: "Date of Receipt",
        accessor: "date_of_receipt",
        render: (data: any) => <>{data.date_of_receipt || "N/A"}</>

    },
    {
        name: "Cheque Number",
        accessor: "cheque_number"
    },
    {
        name: "Cheque Amount",
        accessor: "amount"
    },
    {
        name: "Cedant",
        accessor: "reinsured"
    }],
    "2": [
        {
            name: "Date of Deposit",
            accessor: "date_of_deposit",
            render: (data: any) => <>{data.date_of_deposit || "N/A"}</>

        },
        {
            name: "Payment Details",
            accessor: "cheque_number"
        },
        {
            name: "Amount",
            accessor: "amount"
        },
        {
            name: "Reinsured",
            accessor: "reinsured"
        }
    ],
    "3": [
        {
            name: "Date Of Clearance",
            accessor: "date_cheque_cleared",
            render: (data: any) => <>{data.date_cheque_cleared || "N/A"}</>
        },
        {
            name: "Payment Details",
            accessor: "cheque_number"
        },
        {
            name: "Amount",
            accessor: "amount"
        },
        {
            name: "Reinsured",
            accessor: "reinsured"
        },
    ]
};

const BankingTrayPage = (props: Props) => {
    const [orderStatus] = useUrlState("orderStatus");
    const navigate = useAppNavigate();
    const { items, loading, refetch } = useBankingTray({
        filter: {
            tab_number: !orderStatus ? 1 : Number(orderStatus),
        }
    });

    const expandItem = (id: string) => () => {
        navigate({
            to: `./${id}/view`,
        });
    };

    return (
        <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
            <CalendarHeader />
            <Tabs
                tabs={[{ href: "2", name: "Deposited To Bank" }, { href: "3", name: "Payment Cleared" }]}
                defaultTab="Payment Received"
                orderStatus={orderStatus?.toString()}
            />
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                    <TableComponent
                        title={"Banking Tray"}
                        columns={[
                            ..._.get(tabColumns, !orderStatus ? "1" : orderStatus.toString(), tabColumns["1"]),
                            {
                                name: "Actions",
                                accessor: "actions",
                                render: (data) => (
                                    <>
                                        <ActionButton action="expand" onClick={expandItem(data.offers?.join("-") as string)} />
                                    </>
                                ),
                            }
                        ]}
                        loading={loading}
                        data={items}
                        refetch={refetch}
                    />
                </div>
            </div>
        </main>
    )
}

export default BankingTrayPage